export const IdleTimePage = () => {
  return <>IdleTimePage</>;
};
